import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ifbp-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
    standalone: false
})
export class AuthenticationComponent {
  @Output() navigate = new EventEmitter<string>();

  constructor() { }
}
